import { User } from "authing-js-sdk";

export const checkPhoneCode: (phone: string, code: string) => Promise<User> =
  async (phone, code) => {
    const authing = window.__authing__;
    const user = await authing.loginByPhoneCode(phone, code);
    return user;
  };
